import "./about.scss";

export default function About() {

  return (
    <div className="about" id="about">
      <h1>About Me !</h1>
      <div className="aboutData">
        <div className="text">
          Hello !,
          <br />
          I am Vasanth Kumar, a passionate Computer Science graduate driven by the potential of technology to solve complex problems. My expertise spans Full Stack Web Development, with a strong ability to apply mathematical concepts to real-world engineering challenges.
          <br />
          I hold a Bachelor's degree from Sri Sairam Engineering College (2017–2021). I previously served as an SDE-2 at Amazon India, following a promotion from SDE-1 in December 2023, where I made meaningful contributions to large-scale software systems.
          As of October 2026, I have joined Google as a Software Engineer III (SWE3), marking an exciting new chapter in my career.
          <br />
          For further insights, my resume and social media profiles are available at your convenience.
          I’m enthusiastic about the opportunities ahead and eager to connect for potential collaborations!
          <br />
          <br />

          <div className="socialIcons">
            <a href="https://github.com/VasanthKumar14" target="_blank" rel="noreferrer">
              <img src="assets/github.svg" className="icon" alt="linkedIn" />
            </a>
            <a href="https://www.instagram.com/vasanth_14/" target="_blank" rel="noreferrer">
              <img src="assets/instagram.svg" className="icon" alt="linkedIn" />
            </a>
            <a href="https://www.linkedin.com/in/vasanth-kumar-967810169/" target="_blank" rel="noreferrer">
              <img src="assets/linkedin.svg" className="icon" alt="linkedIn" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=100015949329736" target="_blank" rel="noreferrer">
              <img src="assets/facebook.svg" className="icon" alt="linkedIn" />
            </a>

          </div>


        </div>

        <div className="image">
          <figure>
            <img className="vkImage" src="assets/vk2.jpg" alt="VKphoto" />
          </figure>
        </div>

      </div>

    </div>
  );
}
